
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.37 36.414l3.88 1.94-1.432 1.433c-1.318 1.317.687 3.29 1.989 1.989l2.812-2.813a1.407 1.407 0 00-.365-2.252l-3.88-1.94 1.433-1.433c1.314-1.314-.672-3.305-1.989-1.989l-2.813 2.813a1.407 1.407 0 00.366 2.252z","fill":"#131314"}}),_c('path',{attrs:{"d":"M1.406 48h45.188a1.406 1.406 0 000-2.813h-1.5V18.282c0-1.043-1.101-1.725-2.035-1.258l-3.59 1.795V7.031a1.406 1.406 0 00-2.813 0v13.194l-2.812 1.406v-3.35c0-1.043-1.1-1.725-2.035-1.258l-3.59 1.795V7.031a1.406 1.406 0 00-2.813 0v13.194l-2.812 1.406v-3.35c0-1.043-1.1-1.725-2.035-1.258l-3.59 1.795V7.031a1.406 1.406 0 00-2.813 0v13.194l-2.812 1.406V1.406C11.344.63 10.714 0 9.938 0H4.311c-.776 0-1.406.63-1.406 1.406v43.782h-1.5a1.406 1.406 0 000 2.812zm7.125-36.75H5.72V8.437H8.53v2.813zM5.72 14.063H8.53v2.812H5.72v-2.813zm14.062 6.494v3.35c0 1.043 1.101 1.724 2.035 1.257l9.215-4.607v3.35c0 1.043 1.1 1.725 2.035 1.257l9.215-4.607v24.63H11.344V24.776l8.437-4.218zM8.531 2.813v2.812H5.72V2.812H8.53zM5.72 19.688H8.53v25.5H5.72v-25.5z","fill":"#131314"}})])
          )
        }
      }
    